export enum refUserTypes {
  REF_TYPE_BUSINESS_USER = 'REF_TYPE_BUSINESS_USER',
  REF_TYPE_BUSINESS_UBO_GUEST_USER = 'REF_TYPE_BUSINESS_UBO_GUEST_USER',
  REF_TYPE_INVITED_USER = 'REF_TYPE_INVITED_USER',
}
